/** 格式化工具函数。 */

/** 格式化货币金额（元 → ¥1,234）。 */
export function formatCurrency(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) return "—";
  return `¥${Math.round(amount).toLocaleString()}`;
}

/** 格式化百分比。 */
export function formatPercent(rate: number | null | undefined): string {
  if (rate === null || rate === undefined) return "—";
  return `${rate.toFixed(1)}%`;
}

/** 格式化日期（ISO → YYYY-MM-DD）。 */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** 格式化日期时间。 */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${formatDate(iso)} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

/** 相对时间（x分钟前/x小时前/x天前）。 */
export function formatRelativeTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const now = new Date();
  const d = new Date(iso);
  const diffMs = now.getTime() - d.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);
  if (diffMin < 1) return "刚刚";
  if (diffMin < 60) return `${diffMin}分钟前`;
  if (diffHour < 24) return `${diffHour}小时前`;
  if (diffDay < 30) return `${diffDay}天前`;
  return formatDate(iso);
}

/** GHS 评级映射。 */
export function ghsRating(score: number): string {
  if (score >= 80) return "优秀";
  if (score >= 70) return "良好";
  if (score >= 60) return "一般";
  if (score >= 40) return "待改进";
  return "较差";
}

/** GHS 评级颜色。 */
export function ghsColor(score: number): string {
  if (score >= 70) return "success.main";
  if (score >= 60) return "info.main";
  if (score >= 40) return "warning.main";
  return "error.main";
}
